import axios from "../../../../../../api/axiosInstance";
import {
  UpdateProductStoreOrderStatusRequest,
  UpdateProductStoreOrderStatusResponse,
} from "./types";

export const updateProductStoreOrderStatus = async (
  uuid: string,
  payload: UpdateProductStoreOrderStatusRequest,
): Promise<UpdateProductStoreOrderStatusResponse> => {
  const response = await axios.patch<UpdateProductStoreOrderStatusResponse>(
    `/api/private/product-store/orders/${uuid}/status`,
    payload,
  );
  return response.data;
};
